import angular from 'angular'
import namedInputModule from './namedInput/namedInput'
import transcludeReplaceModule from '../../transcludeReplace/transcludeReplace'
import formRepeatSectionModule from '../formRepeatSection/formRepeatSection'

import inputContainerComponent from './inputContainer.component'

export default angular.module('app.common.forms.inputContainer', [namedInputModule.name, transcludeReplaceModule.name, formRepeatSectionModule.name])
  .directive('inputContainer', inputContainerComponent)
